import { render, staticRenderFns } from "./ListarAgendamento.vue?vue&type=template&id=5bd40868&scoped=true&"
import script from "./ListarAgendamento.vue?vue&type=script&lang=js&"
export * from "./ListarAgendamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd40868",
  null
  
)

export default component.exports